import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "./../../base/core";
import { ServiceRoute } from "./../../base/service-route";
import { CommonHttpOption } from "./../../base/common-http-option";
import { IPlacementTimeSheet } from "src/app/interfaces/placementTimeSheet";
import { IPlacementTimeSheetGetDateList } from "src/app/interfaces/placement-timeSheet-GetDateList";

@Injectable({
  providedIn: "root"
})
export class PlacementTiemSheetService {
  constructor(private core: CoreService) { }

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.placementTimeSheet.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, 'PlacementDate', true)
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.placementTimeSheet.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IPlacementTimeSheet): Observable<any> {
    return this.core.post(
      ServiceRoute.placementTimeSheet.add,
      data,
      new CommonHttpOption().headers
    );
  }

  GetDateList(data: IPlacementTimeSheetGetDateList): Observable<any> {
    return this.core.post(
      ServiceRoute.placementTimeSheet.getDateList,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IPlacementTimeSheet): Observable<any> {
    return this.core.put(
      ServiceRoute.placementTimeSheet.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.placementTimeSheet.delete,
      new CommonHttpOption().headers,
      data
    );
  }
}
